import React, { useState, useEffect } from "react";
import { useGlobal } from "reactn";
import styles from "./OverlayControl.module.scss";
import LayerSelectorList from "../layerSelector/LayerSelectorList";
import loadData from "../../../assets/data/LoadData";

const OverLayControl = (props) => {
  const { data } = props;
  const [masterData, setMasterData] = useState(undefined);
  // eslint-disable-next-line
  const [showOverlays, setshowOverlays] = useGlobal("showOverlays");

  // master data from data repo
  useEffect(() => {
    if (masterData === undefined) {
        const loadMasterData = async () => {
            fetch('https://flowminder.github.io/school-optimisation-resources-nigeria/summary/stateDataMaster.json')
                .then(response => response.json())
                .then((jsonData) => {
                    setMasterData(jsonData)
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        loadMasterData()
    }
}, [masterData, setMasterData])

  const getLegendData = async (legendName) => {
    const infoURL = `https://flowminder.github.io/school-optimisation-resources-nigeria/tiles/${legendName}/tiles_info.json`
    const legendFile = await loadData(infoURL)
    const legendInfo = {"colours" : legendFile.colours, "labels" : legendFile.labels, "info" : legendFile.info }

    return legendInfo
  }

  function handleChange(event, type) {

    const layerLookup = [...showOverlays];
    if (type === "opacity") {
      const result = layerLookup.find(function (obj) {
        return obj.id === event.name;
      });
      if(result){
        const resultPos = layerLookup.indexOf(result);
        result.opacity = event.values
        layerLookup[resultPos] = result
      }
      setshowOverlays(layerLookup);
    } else {
      if (event.target) {
        const dataID = event.target.getAttribute("data-id");
        const dataType = event.target.getAttribute("data-type");
        const isChecked = event.target.value === "checked" ? false : true;
        const inList =
          layerLookup.filter((layer) => layer.id === dataID).length === 0
            ? false
            : true;
        if (isChecked && !inList) {
          let layerInfo;
          // Add to array
          const layerNode = masterData["national"].overlays;
          const result = layerNode.find(function (obj) {
            return obj.type === dataType;
          });
          layerInfo = result.layers.find(function (obj) {
            return obj.Name === dataID;
          });
          if (layerInfo) {
            getLegendData(dataID).then((value) => {
              const legInfo = value
              layerLookup.push({
                id: dataID,
                url: `${layerInfo.URL}`,
                opacity: 0.5,
                layerColour: "#FFFFFF",
                legendInfo: legInfo
              });
              setshowOverlays(layerLookup);
            })
          }
        } else if (!isChecked && inList) {
          //remove from array
          layerLookup.splice(
            layerLookup.findIndex((item) => item.id === dataID),
            1
          );
          setshowOverlays(layerLookup);
        }
      }
    }
  }

  const createLayerLists = () => {
    if (data !== undefined) {
        const builtLists = data.map((item, i) => {
        return (
            <div className="styles.listInner" key={i}>
            <LayerSelectorList
                data={item.layers}
                dataType={item.type}
                listChange={handleChange}
            />
            </div>
        );
        });
        return builtLists;
    }
  };

  return (
    <div className={styles.layersOuter}>
      <span className={styles.controlTitle}>Overlays</span>
      <div className={styles.listOuter}>{createLayerLists()}</div>
    </div>
  );
};

export default OverLayControl;
